stimulusApp.register(
  "bnr",
  class extends Stimulus.Controller {
    static values = { identifier: String, expires: Number }

    clickHandler() {
      Activity.track(this.identifierValue, "open")
    }

    close(event) {
      event.preventDefault()
      event.stopPropagation()
      this.element.remove()
      Cookies.set(this.identifierValue.replace(/-/g, "_"), "true", {
        expires: this.expiresValue || 7,
      })
      Activity.track(this.identifierValue, "close")
    }
  },
)
